/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios';
import DashboardContext from 'Context';
import { useContext, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';

export default function Redirection() {
  const params = useParams();
  const history = useHistory();
  const { authentication, urldashboard, handelerrors } =
    useContext(DashboardContext);

  const checkUser = async (value) => {
    try {
      const response = await axios.get(
        `${urldashboard}/userManagement/getUserType?cellPhone=${value}`,
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json; charset=utf-8 ',
          },
        }
      );
      const data = await response?.data?.data;
      if (data?.userType === 'Worker') {
        return history.push(`/Worker/${data?.userId}`);
      }
      if (data?.userType === 'Customer') {
        return history.push(`/Customer/${data?.userId}`);
      }
      return history.push(`/`);
    } catch (error) {
      handelerrors(error);
    }
  };

  useEffect(() => {
    checkUser(params?.phoneNumber);
  }, []);

  return (
    <div className='text-center p-5'>
      <h1>در حال انتقال به صفحه مورد نظر هستید...</h1>
    </div>
  );
}
